import { Box, Typography, Button, Avatar } from '@material-ui/core';
import React, { FC } from 'react';
import style from './card.module.scss';

export interface NavigationCardProps {
 color: string;
 icon: any;
 label: string;
}

export const NavigationCard: FC<NavigationCardProps> = ({ color, icon, label }) => (
 <Button className={style.root} style={{ backgroundColor: color }}>
  <Box display='flex' flexDirection='column' alignItems='center'>
   <Avatar className={style.icon}>{icon}</Avatar>
   <Typography variant='h6'>{label}</Typography>
  </Box>
 </Button>
);
